import React from 'react';
import { Skeleton } from '@material-ui/lab';

export default function TimeLineAndDetailsSkeleton() {
    return (
        <>
            <div className="timeline" style={{ width: '75%' }}>
                <Skeleton
                    variant="rect"
                    animation="wave"
                    width="100%"
                    height="160px"
                />
            </div>
            <div className="bag-details-list">
                <Skeleton
                    variant="rect"
                    animation="wave"
                    width="100%"
                    height="235px"
                />
            </div>
        </>
    );
}
